import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { Company } from '@data/models/company.model';
import { buildPageSizeOptions } from '@shared/utils/utilities';

const DEFAULT_LIST_SIZE = 10;

@Component({

    selector: 'syn-companies-table',
    templateUrl: 'companies-table.component.html',
    styleUrls: ['companies-table.component.scss']
})
export class CompaniesTableComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() companies: Company[];
    @Input() displayedColumns = ['id', 'name', 'source', 'tags', 'notes'];
    @Input() message: string;
    @Input() pageSize: Number;
    @Input() pageSizeOptions: Number[] = [];

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    dataSource: MatTableDataSource<Company>;
    showPaginator = false;

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnInit() {
        this.pageSizeOptions = buildPageSizeOptions(this.companies);
        this.pageSize = this.pageSizeOptions.length === 0 ? 0 : DEFAULT_LIST_SIZE;
        this.dataSource = new MatTableDataSource<Company>(this.companies || []);
        this.showPaginator = (this.companies.length > DEFAULT_LIST_SIZE);
    }

    ngOnChanges() {
        if (this.companies && this.dataSource) {
            this.dataSource.data = this.companies;
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

}
